// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__Ow8pp","tyre":"style_tyre__bS0+p"};